import React, { useState, useEffect } from "react";
import "./doc-image.css";

function DocImage({ src, alt, className, id }) {
  const [open, setOpen] = useState(false);

  // Close lightbox on Escape key
  useEffect(() => {
    if (!open) return;
    const handleKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open]);

  // Prevent body scroll when lightbox is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <div
        className={`doc-image-wrapper${className ? ` ${className}` : ""}`}
        onClick={() => setOpen(true)}
        id={id}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && setOpen(true)}
        aria-label="View full image"
      >
        <img src={src} alt={alt || ""} className="doc-image-thumb" />
      </div>

      {open && (
        <div className="doc-lightbox" onClick={() => setOpen(false)}>
          <button
            className="doc-lightbox-close"
            onClick={() => setOpen(false)}
            aria-label="Close image"
          >
            &times;
          </button>
          <div className="doc-lightbox-content">
            <img src={src} alt={alt || ""} className="doc-lightbox-img" />
          </div>
        </div>
      )}
    </>
  );
}

export default DocImage;
